import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  GenericApiErrors,
  GetPreQueuePayload,
  PreQueueInvoicesResponse,
  PreQueueInvoicesPayload,
  ReleasePreQueueInvoicesResponse,
} from './SupplierTypes'
import { getFulfillmentCenterSelected } from 'src/services/fulfillmentCenter/fulfillmentCenterService'

const getPreQueue = async (payload: GetPreQueuePayload) => {
  try {
    const result = await http.get('v2/pre-queue/', { params: { id_fc: payload.fcId } })

    return parseGoodResponse<PreQueueInvoicesResponse>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const releasePreQueueInvoices = async (payload: PreQueueInvoicesPayload) => {
  try {
    const { badge, preQueueId } = payload
    const fc = await getFulfillmentCenterSelected()
    const result = await http.post(`v2/pre-queue/${preQueueId}/release?fulfillment_center_id=${fc?.id}`, {}, {
      headers: {
        'user-barcode': badge,
      },
    })

    return parseGoodResponse<ReleasePreQueueInvoicesResponse>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const removePreQueueInvoices = async (payload: PreQueueInvoicesPayload) => {
  try {
    const { badge, preQueueId } = payload
    await http.delete(`v2/pre-queue/${preQueueId}/remove`, {
      headers: {
        'user-barcode': badge,
      },
    })

    return parseGoodResponse<never>()
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const validateBilletBarcode = async (barcode: string) => {
  try {
    await http.post('v2/recebimento/validate-billet-barcode', {}, {
      params: {
        billet_barcode: barcode,
      },
    })

    return parseGoodResponse<never>()
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const validateExternalPurchaseOrderCode = async (externalPurchaseOrderCode: string) => {
  try {
    await http.get(`v2/receivement/external-purchase/${externalPurchaseOrderCode}/validate`)

    return parseGoodResponse<never>()
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  getPreQueue,
  releasePreQueueInvoices,
  validateBilletBarcode,
  removePreQueueInvoices,
  validateExternalPurchaseOrderCode,
}
